import defaultColor from '@/components/color'

const dataText = JSON.stringify([
    {
        group: '广州机房',
        data: [
            { name: 'Mon', value: 120 },
            { name: 'Tue', value: 200 },
            { name: 'Wed', value: 150 },
            { name: 'Thu', value: 80 },
            { name: 'Fri', value: 70 },
            { name: 'Sat', value: 110 },
        ]
    },
    {
        group: '深圳机房',
        data: [
            { name: 'Mon', value: 100 },
            { name: 'Tue', value: 120 },
            { name: 'Wed', value: 70 },
            { name: 'Thu', value: 60 },
            { name: 'Fri', value: 170 },
            { name: 'Sat', value: 90 },
        ]
    }
])
export default {
    attribute: {
        direction: 'x',
        color: defaultColor,
        xAxis: {
            show: true,
            name: '',
            axisLabel: {
                show: true,
                color: '#6aa9e4',
                fontSize: 13,
                rotate: 0,//倾斜角度-180~180
                interval: ''
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#02438e'
                }
            },
            axisTick: {//x轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: false
            }
        },
        yAxis: {
            show: true,
            name: '',
            type: 'value',
            axisLabel: {
                show: true,
                color: '#6aa9e4',
                fontSize: 13,
                formatter: '{value}'
            },
            axisLine: {
                show: false, // 轴线显示
                lineStyle: {
                    color: '#02438e',
                }
            },
            axisTick: {//y轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: true,
                lineStyle: {
                    color: ['#14477e', '#14477e'],
                    type: 'solid' 
                },
                
            }
        },
        title: {
            text: '',
            //subtext: '纯属虚构',
            left: 'center',
            top: 'top',
            textStyle: {
                fontSize: 18,
                color: '#ccc'
            },
            subtextStyle: { fontSize: 12, color: '#aaa' }
        },
        legend: {
            show: true,
            left: 'center',
            top: 'bottom',
            orient: 'horizontal',
            textStyle: {
                color: '#6aa9e4',
                fontSize: 14
            }
        },
        grid: {
            x: 10, y: 30, x2: 30, y2: 30, containLabel: true
        },
        series: {
            showBackground: false,
            borderRadius: 0,
            barType: 'bar',
            smooth: true,
            barGap: 0.1,
            symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
            label: {
                show: false, //数值
                position: 'top',
                color: '#ddd',
                fontSize: 13,
                unit: ''
            },
            barWidth: 18
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        dataZoom: {show: false,height:15},
        cptTableData: [{ "name": "分组", "value": "", "namekey": "group" },
        { "name": "维度", "value": "", "namekey": "name" },
        { "name": "指标", "value": "", "namekey": "value" }]
    },
    cptDataForm: {
        dataText: dataText, dataSource: 1, pollTime: 0
    },
}

